import styled from '@emotion/styled';
import { PopoverButton } from '@headlessui/react';

export const StyledButton = styled(PopoverButton)`
  cursor: pointer;
  padding: var(--spacing-8) var(--spacing-12) var(--spacing-8) var(--spacing-16);
  font: var(--font-body-xl-bold);
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  border: none;
  background: none;
  color: inherit;
  width: 100%;
  text-align: left;
  border-radius: var(--border-radius-s);
  transition: background 0.3s;

  &[data-open],
  &:hover {
    background-color: var(--color-neutral-20);
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline-width: 2px;
    outline-style: solid;
    outline-color: initial;
  }

  svg {
    transition: transform 0.3s ease;
  }

  &[data-open] svg {
    transform: rotate(180deg);
  }
`;
